import axios from 'axios';

export const paymentApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true, timeout: 65000 });
export const paymentError = error => typeof error.response?.data?.detail === 'string' ? error.response.data.detail : 'This request could not finish. Please retry; payment will be verified before access is granted.';